export default function (state, val) {
    let id = val ? (val.id ? val.id : '') : '';
    let item, newFilter;
    if (id) {
        item = state.filters.filter(i => {
            return i.id === val.id;
        })[0];
    }
    if (!item) {
        newFilter = true;
        item = {
            id: '' + new Date().getTime(),
            name: 'Фильтр ' + (state.filters.length + 1),
            searchClick: true,
            dateType: 1,
            dateStep: 1,
            dateInt: 0,
            dateRound: false,
            SumFrom: 0,
            SumTo: 0,
            AvailableSumFrom: 0,
            AvailableSumTo: 0,
            CurrencyIds: [],
            ContragentId: '',
            ContragentName: '',
            ContragentSearchTypeId: '',
            Number: '',
            Type: '',
            OwnerLegalEntityId: '',
            IsUsed: false,
            IsPayed: false,
        }
    }
    if (val) {
        for (let k in val) {
            if (typeof item[k] !== 'undefined') item[k] = val[k];
        }
    }
    if (newFilter) {
        state.filters.push(item);
    }
}